import { twMerge } from "tailwind-merge";
import { resolveAssetUrl } from "../../../utils/resolveAssetUrl";

type Props = {
  logo: string | undefined;
  bgColor: string | undefined;
  className?: string;
}

export default function FooterDefault({ logo, bgColor, className }: Props) {
  return (
    <footer
      className={twMerge("flex rounded-lg items-center justify-center bg-gray-100 py-4", className)}
      style={{ backgroundColor: bgColor }}
    >
      <img loading='lazy' alt="Logo do checkout" className="max-w-100 max-h-12" src={resolveAssetUrl(logo)} />
    </footer>
  )
}
